import { QuestionMarkCircleIcon, PlayCircleIcon } from '@heroicons/react/24/outline';

const FAQHero = () => {
  return (
    <section className="bg-gradient-to-b from-primary/10 to-background py-16">
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-4xl lg:text-5xl font-bold text-foreground mb-6">
          Frequently Asked <span className="text-primary">Questions</span>
        </h1>

        <p className="text-xl text-muted-foreground mb-10 max-w-3xl mx-auto leading-relaxed">
          Find answers about SeniorThrive features, pricing, safety tools, family coordination, and getting started.
        </p>

        {/* In-app help callout */}
        <div className="max-w-2xl mx-auto bg-card border border-primary/15 rounded-md p-6 shadow-raised">
          <div className="flex items-center justify-center gap-3 mb-3">
            <PlayCircleIcon className="w-6 h-6 text-primary" />
            <h3 className="text-lg font-bold text-foreground">Help Is Built Into the Product</h3>
          </div>
          <p className="text-muted-foreground leading-relaxed">
            Inside SeniorThrive, every feature has a built-in walkthrough tour that takes less
            than one minute. You can try the full platform free during early access, help is
            always one tap away.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQHero;
